import { render, staticRenderFns } from "./plusConfigure.vue?vue&type=template&id=decaa6a0&scoped=true"
import script from "./plusConfigure.vue?vue&type=script&lang=js"
export * from "./plusConfigure.vue?vue&type=script&lang=js"
import style0 from "./plusConfigure.vue?vue&type=style&index=0&id=decaa6a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decaa6a0",
  null
  
)

export default component.exports